// TODO This component will have to be moved probably, once we use undo/redo
//  in other editors like VEP or confirmations
import React from 'react';
import { SuiButton, SuiTooltipPopover } from '@splashthat/sui';

import UndoIcon from 'common/icons/Undo';
import RedoIcon from 'common/icons/Redo';
import { useEditorHistory } from '@splashthat/splash-cms-engine';

const UNDO = 'Undo';
const REDO = 'Redo';

export const UndoRedoButtons = () => {
    const editorHistory = useEditorHistory();
    function undo() {
        editorHistory.undo();
    }

    function redo() {
        editorHistory.redo();
    }

    return (
        <>
            <SuiTooltipPopover align="center" content={<label>{UNDO}</label>}>
                <SuiButton
                    icon={UndoIcon}
                    onClick={undo}
                    disabled={!editorHistory.hasPastStates}
                    variation="overlay-light"
                    size="small"
                    aria-label={UNDO}
                />
            </SuiTooltipPopover>
            <SuiTooltipPopover align="center" content={<label>{REDO}</label>}>
                <SuiButton
                    icon={RedoIcon}
                    onClick={redo}
                    disabled={!editorHistory.hasFutureStates}
                    variation="overlay-light"
                    size="small"
                    aria-label={REDO}
                />
            </SuiTooltipPopover>
        </>
    );
};
